const cards = [ //New projects goes as last ↓ ↓
    {
        h1: "AlParigi Hotel",
        tags: ["UX/UI Design", "Web Design", "Web Development", "Hotel"],
        cover: "/assets/experiments/alparigi.jpg",
        link: "https://behance.net/shots/23638115-AlParigi"
    },
    {
        h1: "Capo Verso Hotel",
        tags: ["UX/UI Design", "Web Design", "Web Development", "Hotel"],
        cover: "/assets/experiments/capoverso.jpg",
        link: "https://behance.net/shots/24398589-CapoVerso"
    },
    {
        h1: "Central Park Boathouse",
        tags: ["UX/UI Design", "Web Design", "Restaurant"],
        cover: "/assets/experiments/boathouse.jpg",
        link: "https://behance.net/shots/24510157-Central-Park-BoatHouse"
    },
    {
        h1: "Formula 1",
        tags: ["UX/UI Design", "Web Design", "Racing", "F1"],
        cover: "/assets/experiments/formula1.jpg",
        link: "https://behance.net/shots/24554044-Formula-1"
    },
    {
        h1: "LadyWorld",
        tags: ["UX/UI Design", "Web Design", "NFT", "Web3"],
        cover: "/assets/experiments/ladyworld.jpg",
        link: "https://behance.net/shots/23638130-LadyWorld"
    },
    {
        h1: "Joe Rogan",
        tags: ["UX/UI Design", "Web Design", "Podcast"],
        cover: "/assets/experiments/joerogan.jpg",
        link: "https://www.behance.net/gallery/230744919/Joe-Rogan"
    },
];

export default cards;